export enum OrderDirection {
  Inbound,
  Outbound,
  Delivery,
  Transfer,
}
